// Google Analytics 4 + Google Ads tracking.
// The base gtag.js tag is loaded statically in public/index.html <head>.
// This module adds SPA page_view tracking, gclid preservation, and
// delegated click-conversion tracking for all outbound links.

const ADS_ID = "AW-18493669110";
const CONV_BUY = `${ADS_ID}/jxkLCPn5yZAdEPb9u_JE`;
const CONV_AFFILIATE = `${ADS_ID}/7cHrCPz5yZAdEPb9u_JE`;
const AFFILIATE_PHONE = "5513981675693";

function g(...args) {
  if (window.gtag) window.gtag(...args);
}

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  initialized = true;
  storeGclid();
  attachClickTracking();
}

// Preserve the gclid on landing (store for the session; never strip the URL).
function storeGclid() {
  try {
    const gclid = new URLSearchParams(window.location.search).get("gclid");
    if (gclid) sessionStorage.setItem("gclid", gclid);
  } catch (e) {
    /* no-op */
  }
}

// GA4 page_view for SPA route changes.
export function trackPageView(path) {
  g("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

// One delegated listener covers every link on every page. Uses beacon transport
// so events are delivered even if the browser starts navigating away.
function attachClickTracking() {
  document.addEventListener(
    "click",
    (e) => {
      const a = e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      const href = a.href || "";
      const text = (a.textContent || "").replace(/\s+/g, " ").trim().slice(0, 120);

      if (href.includes("ybera.us")) {
        g("event", "conversion", { send_to: CONV_BUY, transport_type: "beacon" });
        g("event", "buy_now_click", {
          link_text: text,
          link_url: href,
          transport_type: "beacon",
        });
      } else if (href.includes(AFFILIATE_PHONE)) {
        g("event", "conversion", { send_to: CONV_AFFILIATE, transport_type: "beacon" });
        g("event", "affiliate_whatsapp_click", { transport_type: "beacon" });
      } else if (href.includes("chat.whatsapp.com")) {
        g("event", "whatsapp_group_click");
      }
    },
    true
  );
}
